import { FolkDistanceField } from '../folk-distance-field';
FolkDistanceField.define();
export { FolkDistanceField };
//# sourceMappingURL=folk-distance-field.js.map